"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDrawingTool = void 0;
const tools_1 = require("./tools");
const FabricDrawingModes_1 = require("./FabricDrawingModes");
const drawingTools = {
    [FabricDrawingModes_1.DrawingMode.DRAW_LINE_CUT]: tools_1.lineCutTool,
    [FabricDrawingModes_1.DrawingMode.DRAW_POLYGON_ADD]: tools_1.polygonAddTool,
    [FabricDrawingModes_1.DrawingMode.DRAW_LINE_STRING_ADD_POLYGON_BUFFER]: tools_1.addBufferStripTool,
    [FabricDrawingModes_1.DrawingMode.DRAW_FIELD_POLYGON_BUFFER]: tools_1.bufferTool,
    [FabricDrawingModes_1.DrawingMode.DRAW_CIRCLE_ADD]: tools_1.polygonAddTool,
    [FabricDrawingModes_1.DrawingMode.DRAW_FREEFORM_ADD]: tools_1.polygonAddTool,
    [FabricDrawingModes_1.DrawingMode.DRAW_FREEFORM_CUT]: tools_1.polygonCutTool,
    [FabricDrawingModes_1.DrawingMode.DRAW_FREEFORM_MERGE]: tools_1.polygonMergeTool,
    [FabricDrawingModes_1.DrawingMode.DRAW_FREEFORM_REMOVE]: tools_1.polygonDiffTool,
    [FabricDrawingModes_1.DrawingMode.DRAW_RECTANGLE_ADD]: tools_1.polygonAddTool,
    [FabricDrawingModes_1.DrawingMode.DRAW_RECTANGLE_CUT]: tools_1.polygonCutTool,
    [FabricDrawingModes_1.DrawingMode.DRAW_RECTANGLE_MERGE]: tools_1.polygonMergeTool,
    [FabricDrawingModes_1.DrawingMode.DRAW_RECTANGLE_REMOVE]: tools_1.polygonDiffTool,
    [FabricDrawingModes_1.DrawingMode.DRAW_CIRCLE_MERGE]: tools_1.polygonMergeTool,
    [FabricDrawingModes_1.DrawingMode.DRAW_CIRCLE_REMOVE]: tools_1.polygonDiffTool,
    [FabricDrawingModes_1.DrawingMode.DRAW_CIRCLE_CUT]: tools_1.polygonCutTool,
    [FabricDrawingModes_1.DrawingMode.DRAW_POLYGON_CUT]: tools_1.polygonCutTool,
    [FabricDrawingModes_1.DrawingMode.DRAW_LINE_STRING_CUTTING_STRIP]: tools_1.cutBufferStripTool,
    [FabricDrawingModes_1.DrawingMode.DRAW_POLYGON_MERGE]: tools_1.polygonMergeTool,
    [FabricDrawingModes_1.DrawingMode.DRAW_POLYGON_REMOVE]: tools_1.polygonDiffTool,
    [FabricDrawingModes_1.DrawingMode.FEATURE_EDIT]: tools_1.vertexEditTool,
    [FabricDrawingModes_1.DrawingMode.SCALE_ROTATE]: tools_1.vertexEditTool,
    [FabricDrawingModes_1.DrawingMode.TRASH]: tools_1.trashTool,
};
const getDrawingTool = (mode) => {
    return drawingTools[mode];
};
exports.getDrawingTool = getDrawingTool;
